import { EXPERTISE, UAE } from "../../mock";

const SECTION = "mt-28 md:mt-36 border-t border-[rgba(35,33,28,0.14)] pt-8";
const H2 = "font-display text-[26px] md:text-[36px] tracking-tight";

export const StudioIntro = () => (
  <div className="grid md:grid-cols-12 gap-10 mt-14 md:mt-20 mp-fade" style={{ animationDelay: "0.1s" }} data-testid="studio-intro">
    <div className="md:col-span-7 space-y-6 text-[#4a463d] text-[14px] md:text-[16px] leading-relaxed font-light">
      <p>Medium Plenty is a California-based architecture and interior design firm with completed projects throughout the U.S. and abroad, and a satellite office in Abu Dhabi. We offer a comprehensive approach to architecture and interior design, crafting spaces that are beautiful, highly functional, and deeply personal.</p>
      <p>At its core, our practice values connection: between inspiring people and compelling ideas, between serious talent and lightheartedness, and between thoughtful interiors that blend seamlessly with their sophisticated exteriors.</p>
    </div>
    <div className="md:col-span-4 md:col-start-9 self-end border-t border-[rgba(35,33,28,0.14)] pt-5">
      <p className="font-label text-[10px] text-[#8b8578]">Team CV&rsquo;s available upon request</p>
    </div>
  </div>
);

export const StudioServices = () => (
  <div className={SECTION} data-testid="studio-services">
    <div className="flex items-baseline justify-between mb-14">
      <h2 className={H2}>Services</h2>
    </div>
    <div className="grid md:grid-cols-2 gap-12 md:gap-20">
      {UAE.offerings.map((s) => (
        <div key={s.title}>
          <h3 className="font-display text-[24px] md:text-[28px] tracking-tight mb-5 leading-tight">{s.title}</h3>
          <p className="text-[#5f5a50] text-[14px] leading-relaxed font-light">{s.body}</p>
        </div>
      ))}
    </div>
  </div>
);

export const StudioSectors = () => (
  <div className={SECTION} data-testid="studio-sectors">
    <div className="flex items-baseline justify-between mb-10">
      <h2 className={H2}>Sectors</h2>
    </div>
    <div className="flex flex-wrap md:flex-nowrap items-baseline gap-x-2 gap-y-3 pb-24 md:whitespace-nowrap">
      {EXPERTISE.map((e, i) => (
        <span key={e} className="font-display text-[14px] md:text-[17px] text-[#3d3a33]">
          {e}
          {i < EXPERTISE.length - 1 && <span className="text-[#c9a15f] ml-2">/</span>}
        </span>
      ))}
    </div>
  </div>
);
